import { apiRoutes } from '../../api-routes';
import { httpClient, type AxiosRequestConfig } from '../../util/http-client';
import type { OrderDetail } from './types';

export type GetOrderDetailParams = Record<
  string,
  string | number | boolean | undefined
>;

export const getOrderDetailFn = async (
  orderId: string,
  params?: GetOrderDetailParams,
  config: AxiosRequestConfig = {}
) => {
  const requestConfig: AxiosRequestConfig = {
    ...config,
  };

  if (params ?? config.params) {
    requestConfig.params = {
      ...params,
      ...(config.params as Record<string, unknown>),
    };
  }

  const response = await httpClient.get<OrderDetail>(
    apiRoutes.order.detail(orderId),
    requestConfig
  );

  return response.data;
};
